import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { CoreApiConfiguration } from '../coreApiConfiguration';
import { AllergyType } from '../../../models/core/allergy-type';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';

@Injectable()
export class AllergyTypeService extends ServiceBase {

    private actionUrl: string;
    private headers: Headers;
    private _url: string;

    constructor(private _http: HttpClient, private _configuration: CoreApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._url = this.actionUrl + _configuration.allergyType.url;
    }

    get = (isActive = null): Observable<AllergyType[]> => {
        return this._http.get<any>(this._url + '?isActive=' + isActive);
    }
}